import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NDDTranslationModule } from '@ndk/ng-translation';

import { UserMenuContentComponent } from './content/user-menu-content.component';
import { UserConfigViewEnterpriseComponent } from './view-enterprise/user-menu-view-enterprise.component';
import { UserMenuViewPartnerComponent } from './view-partner/user-menu-view-partner.component';

@NgModule({
    imports: [
        CommonModule,
        NDDTranslationModule,
    ],
    exports: [
        UserConfigViewEnterpriseComponent,
        UserMenuViewPartnerComponent,
        UserMenuContentComponent,
    ],
    declarations: [
        UserConfigViewEnterpriseComponent,
        UserMenuViewPartnerComponent,
        UserMenuContentComponent,
    ],
})
export class UserMenuModule { }
